// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"6fe5b3b6","147":"df149bb1","184":"43dc6ec7","574":"132daa10","641":"6e2b2de3","807":"c47700f2","818":"fe93d877","899":"55a14456","900":"cae57209","996":"bccfa01b"}[chunkId] + ".chunk.js";
};